/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BlockerCategoryEnum } from './blockerCategoryEnum';


/**
 * Serializer for the AppointmentBlockerType model.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentBlockerType { 
    readonly id: number;
    name: string;
    readonly category: BlockerCategoryEnum;
}
export namespace AppointmentBlockerType {
}

export const AppointmentBlockerType_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentBlockerType_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const AppointmentBlockerType_category_Validators: ValidatorFn[] =
    [  Validators.required, ];


